import { AiOutlineInfo } from "react-icons/ai";
import useModal from "../../../../../../hooks/useModal";
import Button from "../../../../../atoms/Button";
import CardHeader from "../../../../../atoms/CardHeader";
import Breadcrumb from "../../../../../molecules/Breadcrumb";
import Modal from "../../../../../molecules/Modal";
import InfoEmpresa from "../../../../../templates/clientes/InfoEmpresa";
import { MdAdd } from "react-icons/md";
import DFUploadDocs from "../../../../DF/DFUploadDocs";
import { getEtapa } from "../../../../../../utils/getEtapa";

const DFEtapaHeader = ({ empresa, caso, etapa, refetch, etapaId, lastData, user }) => {
    const { open: openInfo, close, isOpen } = useModal();
    const { open: openDocs, close: closeDocs, isOpen: isOpenDocs } = useModal();

    return(
        <CardHeader>
            <Breadcrumb
                items={[
                    { label: `${empresa?.name || "cargando..."}`, to: `/clientes/empresas/${empresa?.id}/decide` },
                    { label: "DEFENSA FISCAL", to: `/clientes/empresas/${empresa?.id}/defensa_fiscal` },
                    { label: caso?.origin && caso?.authority ? `${caso.origin} - ${caso.authority}` : "...cargando", to: `/clientes/empresas/${empresa?.id}/defensa_fiscal/${caso?.id}` },
                    { label: `${getEtapa(etapa) || "...cargando"}`, to: `/clientes/empresas/${empresa?.id}/defensa_fiscal/${caso?.id}/${etapa || ""}` },
                ]}
            />
            <div className="flex flex-row gap-2">
                {user && user?.role !== "Client" &&
                    <Button
                        text={<MdAdd size={22} />}
                        bgColor="green"
                        width="w-10"
                        onClick={openDocs}
                    />
                }
                <Button
                    text={<AiOutlineInfo size={22} />}
                    bgColor="black"
                    width="w-10"
                    onClick={openInfo}
                />
            </div>
            {isOpen && empresa &&
                <Modal title="Información" onClose={close}>
                    <InfoEmpresa empresa={empresa} />
                </Modal>
            }
            {isOpenDocs &&
                <Modal title="Agregar documento" onClose={closeDocs} heigth="min-h-[85vh]" >
                    <DFUploadDocs onClose={closeDocs} refetch={refetch} etapa={etapa} etapaId={etapaId} lastData={lastData} />
                </Modal>
            }
        </CardHeader>
    );
}

export default DFEtapaHeader;